import { env } from './env';

const ENDPOINT_PATH = '/functions/v1/contact-form-submit';

export type ContactErrorCode =
  | 'invalid_payload'
  | 'recaptcha_failed'
  | 'rate_limited'
  | 'recaptcha_unreachable'
  | 'internal_error'
  | 'method_not_allowed'
  | 'network';

export type ContactResult = { ok: true } | { ok: false; code: ContactErrorCode };

export type PostContactInput = {
  fullName: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
  recaptchaToken: string;
  locale: string;
};

export async function postContactForm(input: PostContactInput): Promise<ContactResult> {
  if (!env.supabase.url || !env.supabase.anonKey) {
    return { ok: false, code: 'internal_error' };
  }

  let resp: Response;
  try {
    resp = await fetch(`${env.supabase.url}${ENDPOINT_PATH}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: env.supabase.anonKey,
        Authorization: `Bearer ${env.supabase.anonKey}`,
      },
      body: JSON.stringify({
        full_name: input.fullName,
        email: input.email,
        phone: input.phone || '',
        subject: input.subject,
        message: input.message,
        recaptcha_token: input.recaptchaToken,
        locale: input.locale,
      }),
    });
  } catch {
    return { ok: false, code: 'network' };
  }

  if (resp.status === 201) {
    return { ok: true };
  }

  const errorBody = (await resp.json().catch(() => null)) as {
    code?: string;
  } | null;

  const code = mapStatusToCode(resp.status, errorBody?.code);
  return { ok: false, code };
}

function mapStatusToCode(status: number, edgeCode: string | undefined): ContactErrorCode {
  switch (edgeCode) {
    case 'invalid_payload':
    case 'recaptcha_failed':
    case 'rate_limited':
    case 'recaptcha_unreachable':
    case 'internal_error':
    case 'method_not_allowed':
      return edgeCode;
  }
  if (status === 400) return 'invalid_payload';
  if (status === 403) return 'recaptcha_failed';
  if (status === 405) return 'method_not_allowed';
  if (status === 429) return 'rate_limited';
  if (status === 502) return 'recaptcha_unreachable';
  return 'internal_error';
}
